import { Flex } from "@goodfill/ui-components";
import { useTranslation } from "react-i18next";
import { BondFiltersDropdown } from "./filter/BondFiltersDropdown";
import { BondFilterCriteria } from "./filter/BondFilterCriteria";
import { BondFilterDataConstraints } from "./filter/BondFilterDataConstraints";
import { BondFilterFavoriteIcon as BondFilterFavorite } from "./filter/filters/BondFilterFavorite";
import { SortingDropdown, SortingDropdownProps } from "./sort/SortingDropdown";
import { BondFilter, BondFilterChange } from "./filter/BondFilter";
import { BondCardViewSelector, BondListViewId, viewItems } from "../card/BondCardViewSelector";
import { bondFilterSearch } from "./filter/bondFilters";
import "./styles/SortAndFilterTools.styles.scss";

type Props = SortingDropdownProps & {
  bondFilters: BondFilter[];
  constraints: BondFilterDataConstraints;
  criteria: BondFilterCriteria;
  defaultCriteria: BondFilterCriteria;
  favoriteBonFilter: BondFilterFavorite;
  numItems?: number;
  onFilterChange: (change: BondFilterChange) => void;
  selectedViewId: BondListViewId;
  setSelectedViewId: (id: BondListViewId) => void;
  totalItems?: number;
};

export const SortAndFilterTools: React.FC<Props> = ({
  criteria,
  defaultCriteria,
  numItems,
  onFilterChange,
  selectedSortDirection,
  selectedSortKey,
  setSelectedSortDirection,
  setSelectedSortKey,
  totalItems,
  ...props
}) => {
  const { t } = useTranslation();

  const feedbackMessage =
    typeof numItems === "number" && typeof totalItems === "number" && numItems > 0 && numItems !== totalItems
      ? t("search.bondCount", {
          num: numItems,
          total: totalItems,
        })
      : "";

  console.log("Filtering:", feedbackMessage);

  return (
    <Flex direction="rowCol" justify="between" gap={4} grow={1} className="filter-select">
      <Flex items="center" gap={1} className="center-items-on-sm">
        <BondCardViewSelector
          items={viewItems}
          setSelectedViewId={props.setSelectedViewId}
          selectedViewId={props.selectedViewId}
        />
        <props.favoriteBonFilter.component
          constraints={props.constraints}
          criteria={criteria}
          onChange={onFilterChange}
          defaultCriteria={defaultCriteria}
        />
      </Flex>
      <Flex grow={1} className="topBar-search-style searchbar-responsive sm-custom-margin-right">
        <bondFilterSearch.component
          criteria={criteria}
          constraints={props.constraints}
          defaultCriteria={defaultCriteria}
          onChange={onFilterChange}
        />
      </Flex>
      <Flex justify="end" className="center-items-on-sm">
        <Flex direction="row" gap={2}>
          <BondFiltersDropdown
            criteria={criteria}
            constraints={props.constraints}
            bondFilters={props.bondFilters}
            onFilterChange={onFilterChange}
          />
          <div className="divider divider-gap" />
          <SortingDropdown
            selectedSortDirection={selectedSortDirection}
            selectedSortKey={selectedSortKey}
            setSelectedSortDirection={setSelectedSortDirection}
            setSelectedSortKey={setSelectedSortKey}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
